import { ScrollButtons } from 'thalia-elements/modules/lists/scroll-buttons/main.js';

class BuchhaendlerListe extends HTMLElement {

    constructor() {
        super();
        this.scrollButtons = null;
    }

    connectedCallback() {
        const liste = this.querySelector('.slider-liste');
        if (!liste) {
            return;
        }
        this.scrollButtons = new ScrollButtons(liste);
        this.scrollButtons.init();

        this.globaleVariablenDeklarieren();
        this.initBuchhaendlerSelectionHandler();
    }

    disconnectedCallback() {
        this.scrollButtons?.destroy();
    }

    globaleVariablenDeklarieren() {
        this.produktlisteContainer = this.querySelector('.produktliste-container');
    }

    initBuchhaendlerSelectionHandler() {
        if (!this.produktlisteContainer) {
            return;
        }

        const fetchDetailsCallback = this.fetchDetails;
        const deeplinkDetails = this.dataset.deeplinkDetails;
        const container = this.produktlisteContainer;

        const radioButtons = this.querySelectorAll('input[name="lbh"]');

        for (const radioButton of radioButtons) {
            radioButton.addEventListener('change', function(e) {
                if (this.checked) {
                    fetchDetailsCallback(deeplinkDetails, this.id, container);
                }
            });
        }

        setTimeout(() => {
            const initiallyCheckedRadioButton = this.querySelector('input[name="lbh"]:checked');
            fetchDetailsCallback(deeplinkDetails, initiallyCheckedRadioButton.id, container);
        }, 100);

  }

  async fetchDetails(deeplinkDetails, bewerterId, container) {
        if (!deeplinkDetails || !bewerterId) {
            return;
        }

        fetch(deeplinkDetails.replace('{bewerterId}', bewerterId)).then(function(response) {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.text();
        }).then(function(responseText) {
            container.innerHTML = responseText;
        });
  }

}
  
if (!customElements.get("buchhaendler-liste")) {
    customElements.define("buchhaendler-liste", BuchhaendlerListe);
}
  